import { pageLocaleHeaders } from 'navigation/localeRequests';
import { showToast } from 'react/toasts/showToast';

export default class Request {
	static cache = {};
	static FROM_HTTP = 1;
	static FROM_WEBSOCKET = 2;

	static _runRequest(url, data = {}, method) {
		const xhr = new window.XMLHttpRequest();
		const promise = new Promise((resolve, reject) => {
			$.ajax({
					type: method,
					url: url,
					data: data,
					xhr: () => {
						return xhr;
					}
				})
				.then(resolve, reject);
		});
		promise.xhrRequest = xhr;
		return promise;
	}

	static generalSend(data, url, callback, errorCallback, method = 'POST') {
		let request = Request._runRequest(url, data, method);
		request.then((response) => {
			if(callback) {
				throw new Error('Callback feature in request is removed');
				// var result = callback(response);
				// if(result === true) {
				// 	require('components/Dashboard').Dashboard.performOpenSearchUpdate(response);
				// }
			}
			return response;
		}, function() {
			if(callback) {
				throw new Error('Callback feature in request is removed');
				// callback({ success: false, serverError: true });
			}
			if(errorCallback) {
				errorCallback();
			}
		});
		/** It is returned here so that the dirty xhrRequest property can be passed with this function */
		return request;
	}

	static get(url, data, callback) {
		return Request.generalSend(data, url, callback, null, 'GET');
	}

	static post(url, data, callback) {
		return Request.generalSend(data, url, callback, null, 'POST');
	}

	static _urlFromAction(action) {
		return `${siteUrl}/api/v1/${action}`;
	}

	static apiv1Get(action, data, callback) {
		return Request.get(Request._urlFromAction(action), data, callback);
	}

	static apiv1Post(action, data, callback) {
		return Request.post(Request._urlFromAction(action), data, callback);
	}

	static apiv1(action, data, callback) {
		return Request.post(siteUrl + '/api/v1/' + action, data, callback);
	}

	static apiv1PostFile(action, data) {
		const formData = new FormData();
		_.each(data, (value, key) => {
			formData.append(key, value);
		});
		let wasOk = false;
		return fetch(`${siteUrl}/api/v1/${action}`,
			{
				method: 'POST',
				headers: pageLocaleHeaders(),
				body: formData
			}
		)
			.then((response) => {
				if(response.ok) {
					wasOk = true;
				}
				return response.json();
			})
			.then((json) => {
				if(wasOk) {
					return json;
				}
				json.responseJSON = { ...json };
				return Promise.reject(json);
			});
	}

	static send(data, action, callback, errorCallback) {
		return Request.generalSend(data, siteUrl + '/matchmaking/' + action, callback, errorCallback);
	}

	static generalJsonError(response = null) {
		console.log('REQUEST ERROR');
		console.error(response);
		let error = null;
		if(!response) {
			error = 'Something went very wrong!';
			showToast({ kind: 'warning', content: error });
			return error;
		}
		if(response.responseJSON) {
			if(response.responseJSON.error) {
				error = response.responseJSON.error;
				showToast({ kind: 'warning', content: error });
				return error;
			}
		}
	}
}


export { Request };